import React from 'react';
import { ContactButton } from './style';

// Leave this component as pure JSX for deployment purposes
export const CustomerChat = () => {
  return (
      <ContactButton href="https://www.messenger.com/t/100527842378255" target="_blank" />
  )
};